import { JSEncrypt } from 'jsencrypt';
const LoginAPI = {
    key() {
        return Request.get('/auth/code')
    },
    login(data, key) {
        return Request.post('/auth/login', { encryptData: this.encrypt(JSON.stringify(data), key) });
    },
    logout() {
        return
        Request.post('http://localhost:9999/logout')
    },
    encrypt(str, pubkey) {
        let encryptor = new JSEncrypt()
        encryptor.setPublicKey(pubkey)
        return encryptor.encrypt(str);
    }
};
export default LoginAPI;